/// <amd-module name="typeahead/core/util/Functional" />

import TypeaheadErrorLogger from "typeahead/core/logging/TypeaheadErrorLogger";
import {ProblemOrigin} from "../logging/ProblemOrigin";
import {Severity} from "../logging/Severity";

// Applies the method named methodName of each target in targets to that target along with the specified args and
// returns a new array with each element being the return value of the function.
export function mapMethodByName<ReturnType, Target>(targets: Target[], methodName: string, ...args: any[]):
        ReturnType[] {
    if (! Array.isArray(targets)) {
        TypeaheadErrorLogger.log(
            new Error("mapMethodByName expected targets to be in an array, but got " + JSON.stringify(targets)),
            Severity.MustFix, ProblemOrigin.UniversalTypeahead);
        return [];
    }
    const returnValues: ReturnType[] = [];
    for (const target of targets) {
        const method = target[methodName];
        if (typeof method === "function") {
            try {
                returnValues.push(method.apply(target, args));
            } catch (e) {
                TypeaheadErrorLogger.log(e, Severity.MustFix, ProblemOrigin.UniversalTypeahead);
            }
        } else {
            TypeaheadErrorLogger.log(new Error(methodName + " is not supported by " + JSON.stringify(target)),
                Severity.MustFix, ProblemOrigin.UniversalTypeahead);
        }
    }
    return returnValues;
}
